export const getAreaCode = (phoneNumber: string): string => {
	const digitsOnly = phoneNumber.replace(/[^\d]/g, '');

	let startIndex = 0;
	if (digitsOnly.length - 10 > 0) {
		startIndex = digitsOnly.length - 10;
	}

	return digitsOnly.substring(startIndex, startIndex + 3);
};

export const getPrefixAndLineNumber = (phoneNumber: string): string => {
	const digitsOnly = phoneNumber.replace(/[^\d]/g, '');

	let startIndex = 0;
	if (digitsOnly.length - 10 > 0) {
		startIndex = digitsOnly.length - 10;
	}

	return digitsOnly.substring(startIndex + 3);
};
